import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskParticipants, isOpenedTaskLoading } from '../../../../../redux/tasks/taskEntities/selectors';
import { toggleTaskWatch } from '../../../../../redux/tasks/actions';
import ConnectedAssigneeSelect from '../../task-components/ConnectedAssigneeSelect';
import { Skeleton } from '@mui/material';

const TaskDetailsCollaborators = ({ isTaskLoading, me, taskId, taskParticipants }) => {
  const dispatch = useDispatch();

  const [watchers, setWatchers] = useState(taskParticipants);
  const [isCollaborator, setIsCollaborator] = useState(
    taskParticipants?.find((user) => user?._id === me?._id),
  );

  useEffect(() => {
    setWatchers(taskParticipants);
  }, [taskParticipants]);

  const currentWatchersValue = useMemo(() => watchers?.map((w) => ({
    value: w?._id || w?.value,
    label: w?.fullName || w?.label,
    email: w?.email,
    avi: w?.avi,
  })), [watchers]);

  const onCollaboratorSelect = useCallback((val) => {
    dispatch(
      toggleTaskWatch(
        taskId,
        true,
        val?.map((v) => v?.value),
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  const handleCollaboratorsSelect = useCallback((e) => setWatchers(e), []);

  const followTaskBtnHandler = useCallback(() => {
    dispatch(
      toggleTaskWatch(taskId, !isCollaborator, [me?._id], () => {
        setIsCollaborator(isCollaborator => !isCollaborator);
        if (isCollaborator) {
          setWatchers(
            taskParticipants
              ?.filter((participant) => participant?._id !== me?._id)
              ?.slice(),
          );
        } else {
          setWatchers([...watchers, me]);
        }
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCollaborator, me, taskId, taskParticipants, watchers]);

  return (
    <div
      className="w-full flex items-center justify-between px-5"
      style={{ zIndex: 12, borderTop: '1px solid rgba(99,102,241,0.08)', paddingTop: 10, paddingBottom: 10 }}
    >
      <div className="flex items-center gap-2">
        <span className="font-semibold" style={{ fontSize: 10, color: 'rgba(15,15,25,0.4)', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
          <FormattedMessage id="COLLABORATORS" defaultMessage="Collaborators" />
        </span>
        {isTaskLoading ? (
          <Skeleton variant="circular" width={22} height={22} />
        ) : (
          <ConnectedAssigneeSelect
            callback={onCollaboratorSelect}
            disableDeselect
            currentValue={currentWatchersValue}
            setCurrentValue={handleCollaboratorsSelect}
            iconSize={24}
            count={5}
          />
        )}
      </div>
      <button
        className="text-xs font-medium px-2.5 py-1 rounded-lg transition-colors"
        style={{ color: 'rgba(99,102,241,0.75)', background: 'rgba(99,102,241,0.07)', border: '1px solid rgba(99,102,241,0.15)' }}
        onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.13)'}
        onMouseLeave={e => e.currentTarget.style.background = 'rgba(99,102,241,0.07)'}
        onClick={followTaskBtnHandler}
      >
        {isCollaborator ? 'Unfollow Task' : 'Follow Task'}
      </button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  me: state?.userReducer?.user,
  taskId: getOpenedTaskId(state),
  taskParticipants: getOpenedTaskParticipants(state),
  isTaskLoading: isOpenedTaskLoading(state),
});

export default connect(mapStateToProps)(TaskDetailsCollaborators);
